





















import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { Referral } from '@/api/model/referral'
import { ValidationObserver } from 'vee-validate'
import { ReferralAPI } from '@/api/backend-client'
import { CommentAPI } from '@/api/backend-client'
import { Comment} from '@/api/model/comment'
import { v4 as uuid } from 'uuid'
import { CommentOrigin, CommentVisibility } from '@/api/types'
import { escapeHtml } from '@/helpers/html'

@Component
export default class ReopenTaskModal extends Vue {
    @Ref() validator!: InstanceType<typeof ValidationObserver>
    @Prop({ type: Boolean, required: true }) visible!: boolean
    @Prop() readonly referral!: Referral
    form: Referral = null
    modalVisible: boolean = false

    @Watch('visible')
    onVisibleChange() {
        this.modalVisible = this.visible
    }

    @Watch('modalVisible')
    onModalVisibleChange() {
        if (this.modalVisible) {
            this.form = this.referral.clone()
            this.$emit('open')
        } else {
            this.form = null
            this.$emit('close')
        }
    }

    submitting: boolean = false
    async submit() {
        const valid = await this.validator.validate()
        if (!valid) {
            setTimeout(() => {
                const errors = this.validator.errors
                const flatErrors = Object.values(errors).flat()

                this.$notify({
                    group: 'validation',
                    type: 'warn',
                    title: this.$t('validationError.title').toString(),
                    text: this.$t('validationError.text', { errors: flatErrors.join('<br>') }).toString().replace(/\n/g, '<br>'),
                })
            }, 32)
            return
        }

        try {
            this.submitting = true

            await ReferralAPI.update(this.form.id, this.form)
            this.referral.update(this.form)

            const comment = await CommentAPI.create(Comment.fromData({
                referral: this.referral.resourceIdentifier,
                user: null,
                id: uuid(),
                comment: this.$t('forms.reopen-task-form.comment', {
                    timestamp: this.$root.$options.filters.datetime(new Date()),
                    userName: this.$currentUser.name,
                }),
                origin: CommentOrigin.SYSTEM,
                visibility: CommentVisibility.PUBLIC,
            }))
            this.referral.comments.push(comment)
            this.$emit('updated')

            this.modalVisible = false
        } catch (error) {
            this.$notify({
                type: 'error',
                title: this.$t('error.title').toString(),
                text: this.$t('error.text', { message: escapeHtml(error.message) }).toString().replace(/\n/g, '<br>'),
            })
        } finally {
            this.submitting = false
        }
    }
}
